/**
 * Name-check outcome statuses, mirroring `NameCheckStatus` in the backend's
 * `services/namecheck/dto.ts`. Kept as named constants so no caller compares bare string
 * literals — a typo in `"PROVDER_ERROR"` would otherwise fall through to the default branch
 * and silently render the wrong card.
 */
export const NAME_CHECK_STATUS = {
  /** payconnect returned an account-holder name. */
  FOUND: "FOUND",
  /** The lookup ran, but payconnect has no name for that account. */
  NOT_FOUND: "NOT_FOUND",
  /** payconnect publishes no code for that bank/network in that country. */
  UNSUPPORTED: "UNSUPPORTED",
  /** payconnect was unreachable or errored. Nothing is known about the account. */
  PROVIDER_ERROR: "PROVIDER_ERROR",
};
